
namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class CartProductsDialog extends Serenity.EntityDialog<CartProductsRow, any> {
        protected getFormKey() { return CartProductsForm.formKey; }
        protected getIdProperty() { return CartProductsRow.idProperty; }
        protected getLocalTextPrefix() { return CartProductsRow.localTextPrefix; }
        protected getNameProperty() { return CartProductsRow.nameProperty; }
        protected getService() { return CartProductsService.baseUrl; }
        protected getDeletePermission() { return CartProductsRow.deletePermission; }
        protected getInsertPermission() { return CartProductsRow.insertPermission; }
        protected getUpdatePermission() { return CartProductsRow.updatePermission; }

        protected form = new CartProductsForm(this.idPrefix);


        loadEntity(entity: CartProductsRow) {
            super.loadEntity(entity);
            //debugger;
           

            this.form.CartProductSpecificationId.change(e => {
                this.onSpecificationChanged();
               
            });
           
        }
       protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            buttons.splice(0,3)
            buttons.push({
                title: Q.text('🛒 Go To Cart'),
                cssClass: 'go-to-cart-btn',
               /* icon: 'fa fa-lock text-green',*/
                onClick: () => {
                   

                    CartService.RetrieveFranchiseeCart({
                        EntityId: 1
                    }, response => {
                        if (response.Entity == null) {
                            Q.notifyError("No Data found in cart");
                        } else {
                            this.dialogClose();
                            let dlg = new CartDialog();
                            dlg.loadByIdAndOpenDialog(response.Entity.Id);
                        }
                    });
                   

                }
            });

           

            return buttons;
        }

        private onSpecificationChanged(): void {
            const productId = Number(this.form.ProductId.value);
            const cartId = this.form.CartId.value;

            // Normalize value to number[]
            let specification: number[] = [];

            const rawValue = this.form.CartProductSpecificationId.value;

            if (Array.isArray(rawValue)) {
                specification = rawValue.map(x => Number(x));
            } else if (typeof rawValue === 'string') {
                specification = rawValue.split(',').map(x => Number(x));
            }

            if (productId && cartId && specification.length > 0) {
                Carts.CartProductsService.AddCartProduct({
                    ProductId: productId,
                    CartId: cartId,
                    Specification: specification
                }, response => {
                   /* Q.notifyInfo('Calculation complete!');*/
                    console.log(response);

                    if (response.Entity) {
                        this.loadEntity(response.Entity);
                    }
                });
            }
        }


    }
}